// Canonical reference: GRAPHICS / Graphic Design Work. No runtime Drive fetch.
// Future sync can map verified images to the same id/source/filename/index records
// below, retaining POSTERS as the local fallback if Drive is unavailable.
export const GRAPHIC_DESIGN_ASSET_SOURCE = {
  folderId: "1CUwXm2lXgWXVNBWXh9or9YhGMbDDm7tn",
  folderUrl: "https://drive.google.com/drive/folders/1CUwXm2lXgWXVNBWXh9or9YhGMbDDm7tn?usp=sharing",
  mode: "local",
};

// Original artwork only. Add final files in assets/posters; webpack discovers them
// on the next build. Numbered folders control order without changing filenames.
const files = require.context("../assets/posters", true, /\.(png|jpe?g|webp|avif)$/i);

export const POSTERS = files.keys().sort().map((key, index) => ({
  id: key.slice(2),
  source: files(key),
  filename: key.split("/").pop(),
  index,
}));
